import { LangApproved, LangApprover, LangPending, LangRejected, LangStatus, LangUpdatedAt, Note } from '../../../../constant/languange'
import { connect, displayDate, mapStateToProps } from '../../../../helpers/Common'

const ApprovalStepsReprimand = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle p-2'>No.</th>
            <th scope='col' className='text-center align-middle p-2'>{LangStatus}</th>
            <th scope='col' className='text-center align-middle p-2'>{LangApprover}</th>
            <th scope='col' className='text-center align-middle p-2'>{Note}</th>
            <th scope='col' className='text-center align-middle p-2'>{LangUpdatedAt}</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{item?.order}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>
                {
                  item.status === 'pending' && <span className='badge badge-warning'>{LangPending}</span>
                }
                {
                  item.status === 'approve' && <span className='badge badge-success'>{LangApproved}</span>
                }
                {
                  item.status === 'reject' && <span className='badge badge-danger'>{LangRejected}</span>
                }
              </td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>
                {item?.is_updated_by_admin ? (
                  <>Admin{item?.updated_by_name ? ` (${item?.updated_by_name})` : ''}</>
                ) : (
                  <>{item?.name}{item?.group ? ` - ${item.group.name}` : ''}</>
                )}
              </td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>{item?.note}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''} p-2`}>
                {item?.updated_at !== null && <>{displayDate(item.updated_at, 'DD MMM YYYY @ HH:mm')}</>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(ApprovalStepsReprimand)
